import { forwardRef, useEffect, useRef, useState } from 'react';
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { CloseIconButton } from '../buttons';
import { redirect, useNavigate } from 'react-router-dom';


export interface ConfirmationItem {
    verificationText: string;
    approveButtonText: string;
    notApproveButtonTest: string;
    redirectUrl:string;
}

interface StateItem {

    isVerified: boolean;
}

interface ConfirmationModalProps {
    showModal: boolean;
    item: ConfirmationItem;
    onVerified: () => void;
    onClose: () => void;
}

const ConfirmationModal = forwardRef((props: ConfirmationModalProps) => {
    const navigate = useNavigate();
    //definitions
    const { item, showModal, onVerified, onClose } = props;
    const initialState: StateItem = {
        isVerified: false,
    };
    const [state, setState] = useState<StateItem>(initialState);

    const handleVerify = async (isOk: boolean) => {

        setState(initialState);
        var verified = isOk;
        if (verified) {
            onVerified();
        }
        else {
            
            if(item.redirectUrl===null||item.redirectUrl===''||item.redirectUrl===undefined)
                {
                    onClose();
                    return;
                }
            else
            {
                onClose();
                window.location.href = item.redirectUrl;
            }
        }
    }
    return (
        <Dialog
            maxWidth="sm"
            fullWidth={true}
            open={showModal}
            onClose={(event, reason) => {
                if (reason && reason === "backdropClick")
                    return;
                onClose();
            }}

            className="ks-modal">
            <DialogTitle className="modal-header" component="div">
                <h4 className="modal-title">
                    Emin misin?
                </h4>
            </DialogTitle>
            <DialogContent dividers>

                <div className='modal-content'>
                    {item.verificationText}
                </div>

            </DialogContent>
            <DialogActions>
                <Button
                    id="approve"
                    color='error'
                    type='button'
                    onClick={() => handleVerify(true)}
                    variant="outlined">
                    {item.approveButtonText}</Button>

                <Button
                    id="notApprove"
                    color='success'
                    type='button'
                    onClick={() => handleVerify(false)}
                    variant="outlined">
                    {item.notApproveButtonTest}</Button>
            </DialogActions>
        </Dialog>
    )
});

export default ConfirmationModal;